document.addEventListener('DOMContentLoaded', function () {
  let closeWindow = false;

  if (document.querySelector('.back-button')) {
    // if the request comes from the email-first page then a flag is switch true,
    // indicating that the back button should close the window
    if (document.referrer.split('/').pop() === 'email-first') {
      closeWindow = true;
    }
  }

  handleClickButton(closeWindow, window, history);
});

//facebook after login fix
if (window.location.hash.indexOf('#_=_') !== -1) {
  history.replaceState(null, null, window.location.href.replace('#_=_', ''));
}

export const handleClickButton = (closeWindow, window, history) => {
  document.querySelector('.back-button')?.addEventListener('click', e => {
    e.preventDefault();

    const url = e.target.dataset.href;

    if (closeWindow) {
      return window.close();
    }

    if (url === 'back' || !url) {
      return history.back();
    }

    return (window.location = url);
  });
};
